export const Home = {
    zh:{
        home: {
            us: {
                title: '为什么选择C30教育云'
            }
        }
    },
    en:{
        home: {
            us: {
                title: 'why choose us?',
            }
        }
    }
}